(() => {
 document.addEventListener('click',event=>{if(event.target.closest('[data-sn-continue-shopping]'))document.querySelector('cart-drawer')?.close();});
 document.addEventListener('sn:cart-added',event=>{
  const box=document.querySelector('cart-drawer [data-sn-cart-success]');if(!box)return;
  const item=event.detail;
  box.querySelector('[data-sn-added-product]').textContent=item.product_title||item.title||'';
  box.querySelector('[data-sn-added-variant]').textContent=[item.variant_title&&item.variant_title!=='Default Title'?item.variant_title:'',box.dataset.quantity+': '+item.quantity].filter(Boolean).join(' · ');
  box.hidden=false;
 });
 let frame;
 function avoidOverlap(){
  if(frame)return;
  frame=requestAnimationFrame(()=>{
   frame=null;const launcher=document.querySelector('.sn-support__launcher');
   if(!launcher||!matchMedia('(max-width:749px)').matches){document.body.classList.remove('sn-support-over-action');return;}
   const r=launcher.getBoundingClientRect();
   const overlap=[...document.querySelectorAll('#MainContent .quick-add__submit,#MainContent .product-form__submit,#MainContent .price')].some(el=>{
    const b=el.getBoundingClientRect();return b.width&&b.height&&b.top<r.bottom+8&&b.bottom>r.top-8&&b.left<r.right+8&&b.right>r.left-8;
   });document.body.classList.toggle('sn-support-over-action',overlap);
  });
 }
 addEventListener('scroll',avoidOverlap,{passive:true});addEventListener('resize',avoidOverlap,{passive:true});document.addEventListener('shopify:section:load',avoidOverlap);avoidOverlap();
})();